import React, {useEffect} from 'react'
import { withComponentLabel } from '../../utils/debug'

const Unsubscribe = () => {
  useEffect(() => {
    const unsubscribe = async () => {
      console.log('Attempting to unsubscribe...')
      const res = await fetch('/api/unsubscribe')
      const data = await res.json()
      console.log('Unsubscription complete with response:', data)
    }
    unsubscribe()
  }, [])

  return (
    <div className='flex-grow text-center flex flex-col items-center'>
      <h3 className='font-extrabold'>Unsubscribe successful</h3>
      <p className='text-xl'>
        You have been unsubscribed from Grocerylist.me emails!
      </p>
    </div>
  )
}

export default withComponentLabel(Unsubscribe, 'Unsubscribe')
